export default __webpack_public_path__ + "static/media/ed2mit2021tuto_A03-data-sql-nosql-v02.e063fef3.pdf";